
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class BrandAmbassadorPaymentsDialog extends Serenity.EntityDialog<BrandAmbassadorPaymentsRow, any> {
        protected getFormKey() { return BrandAmbassadorPaymentsForm.formKey; }
        protected getIdProperty() { return BrandAmbassadorPaymentsRow.idProperty; }
        protected getLocalTextPrefix() { return BrandAmbassadorPaymentsRow.localTextPrefix; }
        protected getNameProperty() { return BrandAmbassadorPaymentsRow.nameProperty; }
        protected getService() { return BrandAmbassadorPaymentsService.baseUrl; }
        protected getDeletePermission() { return BrandAmbassadorPaymentsRow.deletePermission; }
        protected getInsertPermission() { return BrandAmbassadorPaymentsRow.insertPermission; }
        protected getUpdatePermission() { return BrandAmbassadorPaymentsRow.updatePermission; }

        protected form = new BrandAmbassadorPaymentsForm(this.idPrefix);

    }
}